/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactQuill, { Quill } from 'react-quill';
import BlotFormatter, {
  AlignAction,
  DeleteAction,
  ImageSpec,
  ResizeAction,
} from 'quill-blot-formatter';
import { useEffect } from 'react';
import 'react-quill/dist/quill.snow.css';
import './style.less';

Quill.register('modules/blotFormatter', BlotFormatter);

class CustomImageSpec extends ImageSpec {
  getActions() {
    return [AlignAction, DeleteAction, ResizeAction];
  }
}

type Props = {
  readyOnly?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  toolbar?: Record<string, any> & {
    container?: any[];
    handlers?: Record<string, any>;
  };
  style?: React.CSSProperties;
  initialConfig?: VoidFunction;
  removeDefaultTools?: boolean;
};

const toolBarContainerDefault = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],

  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],

  ['image'],

  ['clean'],
];

const EmailTextInput: React.FC<Props> = (props) => {
  useEffect(() => {
    if (props.initialConfig) {
      props.initialConfig();
    }
  }, [props.initialConfig]);

  return (
    <ReactQuill
      value={props?.value || ''}
      onChange={props.onChange}
      className="email-editor"
      theme="snow"
      style={props.style}
      readOnly={props.readyOnly}
      modules={{
        blotFormatter: {
          specs: [CustomImageSpec],
          overlay: {
            style: {
              border: '1px solid gray',
            },
          },
        },

        toolbar: {
          ...props?.toolbar,

          container: [
            ...(props.toolbar?.container || []),

            ...(props?.removeDefaultTools ? [] : toolBarContainerDefault),
          ],
        },
      }}
    />
  );
};

export default EmailTextInput;
